import Vue from 'vue'
import App from './App.vue'
import './assets/tailwind.css'
import '@/utensil/filble'
import '@/utensil/basic.css'
import '@/utensil/fonts.css'
import router from './router'
import axios from 'axios'
import moment from 'moment'
Vue.config.productionTip = false
Vue.config.productionTip = false
// const currentIP = window.location.hostname;
axios.defaults.baseURL = `https://ndzihua.xyz/api` // 统一基础路径
axios.defaults.timeout = 5000 // 超时时间 5 秒
Vue.prototype.moment = moment
Vue.prototype.$axios = axios
new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
